module.exports = __webpack_public_path__ + "static/media/logo.e253dd55.png";